// src/components/BlockUserDialog.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button } from '@mui/material';

const BlockUserDialog = ({ open, onClose, onConfirm, userName }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Block {userName}?</DialogTitle>
      <DialogContent>
        <Typography>
          Blocked users will no longer be able to message you or find your profile. They will be removed from your friends list.
        </Typography>
        <Typography sx={{ mt: 2, fontWeight: 'bold' }}>
          Are you sure you want to block {userName}?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: '0 24px 24px' }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          Block
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BlockUserDialog;